/* eslint jsx-a11y/aria-role: 0 */
/* eslint array-callback-return: 0 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Link
} from 'react-router-dom'
import './customertypebar.css';
import CategoryButton from '../CategoryButton';

import * as uri from '../../config/uri';
/* dropdown menu */
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { getSvgIcon } from '../../helpers/productHelper.js'
import { scrollTo } from '../../actions/view'
import { hideCategoryBar, showCategoryBar } from '../../reducers/viewReducer';
import { isPaymentKiosk as isPaymentKioskSelector, getCategories } from '../../selectors/configSelectors';
import CustomerTypeButton from './CustomerTypeButton';
import { getSelectedCustomerType } from "../../selectors/customer_type_selector";
import { updateCustomerType } from '../../actions/customer_type_actions';
import CustomerTypes from '../../const/customer_type.js'
import { RECREATIONAL_TEXT } from '../../const/cart_const';

class CustomerTypeBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    }
  }

  changeCustomerType = (customerType) => {
    this.props.updateCustomerType(customerType);
  }

  render() {
    const { active } = this.props;
    const { selectedCustomerType } = this.props;

    return (
      <div className="filter-section">
        <FilterSection isFetching={this.props.productsFetching} className="filter-content">
          <div role="cust-filter" className="customer-type-bar">
            <CustomerTypeButton
              active={selectedCustomerType === CustomerTypes.ADULT}
              onClick={this.changeCustomerType.bind(this, CustomerTypes.ADULT)}
              name={RECREATIONAL_TEXT}
            />

            <CustomerTypeButton
              active={selectedCustomerType === CustomerTypes.MEDICAL}
              onClick={this.changeCustomerType.bind(this, CustomerTypes.MEDICAL)}
              name={CustomerTypes.MEDICAL}
            />
          </div>
        </FilterSection>
      </div>
    );
  }
}

const FilterSection = styled.div`
  z-index: 0;
`;

const mapStateToProps = (state) => {
  return {
    selectedCustomerType: getSelectedCustomerType(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCustomerType: customerType => dispatch(updateCustomerType(customerType))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTypeBar);



// WEBPACK FOOTER //
// ./src/components/CustomerTypeBar/CustomerTypeBar.jsx